export const SIGN_IN_USER_REQ = 'SIGN_IN_USER_REQ';
export const SIGN_IN_USER_OK = 'SIGN_IN_USER_OK';
export const SIGN_IN_USER_ERR = 'SIGN_IN_USER_ERR';
export const SIGN_UP_USER_REQ = 'SIGN_UP_USER_REQ';
export const SIGN_UP_USER_OK = 'SIGN_UP_USER_OK';
export const SIGN_UP_USER_ERR = 'SIGN_UP_USER_ERR';
export const USER_AUTHORIZE_REQ = 'USER_AUTHORIZE_REQ';
export const USER_AUTHORIZE_OK = 'USER_AUTHORIZE_OK';
export const USER_AUTHORIZE_ERR = 'USER_AUTHORIZE_ERR';
export const USER_LOG_OUT = 'USER_LOG_OUT';
export const VERIFY_USER_SIGN_UP_REQ = 'VERIFY_USER_SIGN_UP_REQ';
export const VERIFY_USER_SIGN_UP_OK = 'VERIFY_USER_SIGN_UP_OK';
export const VERIFY_USER_SIGN_UP_ERR = 'VERIFY_USER_SIGN_UP_ERR';
export const GET_LAST_VERIFICATION_EMAIL_INFO_REQ = 'GET_LAST_VERIFICATION_EMAIL_INFO_REQ';
export const GET_LAST_VERIFICATION_EMAIL_INFO_OK = 'GET_LAST_VERIFICATION_EMAIL_INFO_OK';
export const RESET_LAST_VERIFICATION_EMAIL_INFO_REQ = 'RESET_LAST_VERIFICATION_EMAIL_INFO_REQ';
export const GET_PROFILE_REQ = 'GET_PROFILE_REQ';
export const GET_PROFILE_OK = 'GET_PROFILE_OK';
export const UPDATE_PROFILE_REQ = 'UPDATE_PROFILE_REQ';
export const UPDATE_PROFILE_OK = 'UPDATE_PROFILE_OK';
export const CHANGE_PASSWORD_REQ = 'CHANGE_PASSWORD_REQ';
export const CHANGE_PASSWORD_OK = 'CHANGE_PASSWORD_OK';
export const CHANGE_PASSWORD_ERR = 'CHANGE_PASSWORD_ERR';
export const REQUEST_PASSWORD_RESTORE_EMAIL_REQ = 'REQUEST_PASSWORD_RESTORE_EMAIL_REQ';
export const RESTORE_PASSWORD_REQ = 'RESTORE_PASSWORD_REQ';
export const RESTORE_PASSWORD_OK = 'RESTORE_PASSWORD_OK';
export const CHECK_IF_RESTORING_PASSWORD_AVAILABLE_REQ = 'CHECK_IF_RESTORING_PASSWORD_AVAILABLE_REQ';
export const CHECK_IF_RESTORING_PASSWORD_AVAILABLE_OK = 'CHECK_IF_RESTORING_PASSWORD_AVAILABLE_OK';
export const GET_USER_BALANCE_REQ = 'GET_USER_BALANCE_REQ';
export const GET_USER_BALANCE_OK = 'GET_USER_BALANCE_OK';

export const GET_GOOGLE_OAUTH_URL_REQ = 'GET_GOOGLE_OAUTH_URL_REQ';
export const GET_GOOGLE_OAUTH_URL_OK = 'GET_GOOGLE_OAUTH_URL_OK';

export const GOOGLE_SIGN_UP_REQ = 'GOOGLE_SIGN_UP_REQ';
export const GOOGLE_SIGN_UP_OK = 'GOOGLE_SIGN_UP_OK';

export const GOOGLE_SIGN_IN_REQ = 'GOOGLE_SIGN_IN_REQ';
export const GOOGLE_SIGN_IN_OK = 'GOOGLE_SIGN_IN_OK';

export const GET_GITHUB_OAUTH_URL_REQ = 'GET_GITHUB_OAUTH_URL_REQ';
export const GET_GITHUB_OAUTH_URL_OK = 'GET_GITHUB_OAUTH_URL_OK';

export const GITHUB_SIGN_UP_REQ = 'GITHUB_SIGN_UP_REQ';
export const GITHUB_SIGN_UP_OK = 'GITHUB_SIGN_UP_OK';

export const GITHUB_SIGN_IN_REQ = 'GITHUB_SIGN_IN_REQ';
export const GITHUB_SIGN_IN_OK = 'GITHUB_SIGN_IN_OK';

export const ASSIGN_GITHUB_ACCOUNT_REQ = 'ASSIGN_GITHUB_ACCOUNT_REQ';
export const GET_GITHUB_INTEGRATION_TOKEN_BY_CODE_REQ = 'GET_GITHUB_INTEGRATION_TOKEN_BY_CODE_REQ';

export const GET_PAYMENT_HISTORY_REQ = 'GET_PAYMENT_HISTORY_REQ';
export const GET_PAYMENT_HISTORY_OK = 'GET_PAYMENT_HISTORY_OK';
export const GET_PAYMENT_HISTORY_ERR = 'GET_PAYMENT_HISTORY_ERR';

export const GET_GITHUB_PROMO_INFO_REQ = 'GET_GITHUB_PROMO_INFO_REQ';
export const GET_GITHUB_PROMO_INFO_OK = 'GET_GITHUB_PROMO_INFO_OK';
export const GET_GITHUB_PROMO_INFO_ERR = 'GET_GITHUB_PROMO_INFO_ERR';

export const GET_PLANS_REQ = 'GET_PLANS_REQ';
export const GET_PLANS_OK = 'GET_PLANS_OK';

export const CHANGE_PLAN_REQ = 'CHANGE_PLAN_REQ';
export const CHANGE_PLAN_OK = 'CHANGE_PLAN_OK';

export const GET_USER_PAYMENT_METHODS_REQ = 'GET_USER_PAYMENT_METHODS_REQ';
export const GET_USER_PAYMENT_METHODS_OK = 'GET_USER_PAYMENT_METHODS_OK';

export const VERIFY_PLAN_REQ = 'VERIFY_PLAN_REQ';
export const VERIFY_PLAN_OK = 'VERIFY_PLAN_OK';

export const RESET_NEXT_PLAN_TRANSITION_REQ = 'RESET_NEXT_PLAN_TRANSITION_REQ';

export const SHOW_CHANGE_PLAN_POPUP = 'SHOW_CHANGE_PLAN_POPUP';

export const CANCEL_ENTERPRISE_SUBSCRIPTION_REQ = 'CANCEL_ENTERPRISE_SUBSCRIPTION_REQ';
export const RESUME_ENTERPRISE_SUBSCRIPTION_REQ = 'RESUME_ENTERPRISE_SUBSCRIPTION_REQ';

export const GET_GITHUB_LOGIN_NAME_REQ = 'GET_GITHUB_LOGIN_NAME_REQ';
export const GET_GITHUB_LOGIN_NAME_OK = 'GET_GITHUB_LOGIN_NAME_OK';
export const GET_GITHUB_LOGIN_NAME_ERR = 'GET_GITHUB_LOGIN_NAME_ERR';

export const REDIRECT_AFTER_GITHUB_OAUTH_ERR_REQ = 'REDIRECT_AFTER_GITHUB_OAUTH_ERR_REQ';

export const INVITE_FRIENDS_REQ = 'INVITE_FRIENDS_REQ';

export const GET_INVITED_FRIENDS_INFO_REQ = 'GET_INVITED_FRIENDS_INFO_REQ';
export const GET_INVITED_FRIENDS_INFO_OK = 'GET_INVITED_FRIENDS_INFO_OK';

export const GET_RESOURCE_USAGE_REQ = 'GET_RESOURCE_USAGE_REQ';
export const GET_RESOURCE_USAGE_OK = 'GET_RESOURCE_USAGE_OK';